import { useLayoutEffect } from 'react';

import { useMixpanel } from './useMixpanel';

export function useMixpanelTrack(name: string | undefined) {
	const mixpanel = useMixpanel();

	useLayoutEffect(() => {
		if (name) {
			mixpanel?.track(name);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [name, !!mixpanel]);
}
